// =============================================================================
// TYPES
// =============================================================================

export interface AltitudeElement {
  type: 'Altitude';
  params: {
    /** Parent shape ID (Triangle, Parallelogram, Trapezoid) */
    of: string;
    /** Vertex name to drop altitude from: 'A'|'B'|'C' for Triangle, 'A'|'B'|'C'|'D' for quads */
    from: string;
  };
}
